// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQs_root__M5pFF","faqWrapper":"FAQs_faqWrapper__tje0L"};